import { FC } from 'react';
import { Empty } from 'antd';
import striptags from 'striptags';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { Container } from '../../components/container/container';
import { PageBanner } from '../../components/page-banner/page-banner';
import { BreadcrumbItem } from '../../components/breadcrumb/breadcrumb';
import { IJourney, IJourneyService } from '../../apis/journeys';

export interface JourneyProps {
  journey?: IJourney;
  breadcrumbs: BreadcrumbItem[];
  onClickService: (service: IJourneyService) => void;
}

export const Journey: FC<JourneyProps> = ({
  journey,
  breadcrumbs,
  onClickService,
}) => (
  <div className="xvia-journey">
    <PageBanner
      bannerTitle={journey?.title || 'Jornada do Cidadão'}
      bannerImage={`${process.env.PUBLIC_URL}/images/banner/banner_letters_services.png`}
      breadcrumbs={breadcrumbs}
    />
    <Container className="xvia-journey__container">
      {!journey && <Empty description="Jornada não encontrada" />}

      {journey && (
        <>
          {!!journey.audiences?.length && (
            <div className="xvia-journey__audiences">
              {journey.audiences.map((audience) => (
                <span key={audience.id} className="xvia-journey__audience">
                  {audience.name}
                </span>
              ))}
            </div>
          )}

          {journey.description && (
            <p className="xvia-journey__description">
              {striptags(journey.description)}
            </p>
          )}

          <ol className="xvia-journey__steps">
            {journey.steps.map((step, index) => (
              <li key={step.id} className="xvia-journey__step">
                <div className="xvia-journey__step_marker">
                  <span className="xvia-journey__step_number">{index + 1}</span>
                </div>
                <div className="xvia-journey__step_body">
                  <h3 className="xvia-journey__step_title">{step.title}</h3>
                  {step.description && (
                    <p className="xvia-journey__step_description">
                      {striptags(step.description)}
                    </p>
                  )}

                  {step.services.length ? (
                    <ul className="xvia-journey__services">
                      {step.services.map((service) => (
                        <li key={service.id}>
                          <button
                            type="button"
                            className="xvia-journey__service"
                            onClick={() => onClickService(service)}
                          >
                            <span className="xvia-journey__service_name">
                              {service.name}
                            </span>
                            {service.organization && (
                              <span className="xvia-journey__service_org">
                                {service.organization}
                              </span>
                            )}
                            <ArrowForward />
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="xvia-journey__step_empty">
                      Serviços desta etapa em breve.
                    </p>
                  )}
                </div>
              </li>
            ))}
          </ol>

          {!journey.steps.length && (
            <Empty description="Esta jornada ainda não tem etapas publicadas" />
          )}
        </>
      )}
    </Container>
  </div>
);
